export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'guide', name: '使用指南', description: '详细的平台使用教程与操作指引，帮助您快速上手98堂各项功能。', icon: 'ri-book-open-line' },
  { slug: 'faq', name: '常见问题', description: '汇集用户最常见的问题与解答，快速解决您在使用过程中遇到的困惑。', icon: 'ri-question-answer-line' },
  { slug: 'security', name: '安全公告', description: '最新的平台安全动态与公告通知，保障您的账户安全与访问稳定。', icon: 'ri-shield-flash-line' },
  { slug: 'news', name: '平台动态', description: '98堂平台最新资讯、功能更新与服务优化动态。', icon: 'ri-newspaper-line' },
];

export interface Article {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  date: string;
  readTime: string;
  views: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: '98堂新用户注册与登录完整教程',
    category: 'guide',
    excerpt: '本教程将详细介绍98堂平台的注册流程、登录方式以及账户安全设置，帮助新用户快速完成首次登录。',
    content: `<p>欢迎加入98堂！本文将为您详细介绍从注册到登录的完整流程，帮助您顺利开启98堂之旅。</p>
<h3>一、注册账号</h3>
<p>访问98堂官方入口后，点击页面右上角的"注册"按钮。您需要填写以下信息：</p>
<ul>
<li><strong>用户名</strong>：4-16位字符，支持中英文和数字组合</li>
<li><strong>密码</strong>：8-20位，需包含字母和数字，建议加入特殊字符提升安全性</li>
<li><strong>手机号</strong>：用于接收验证码和账户安全验证</li>
<li><strong>邮箱</strong>（选填）：用于接收重要通知和找回密码</li>
</ul>
<p>填写完成后点击"获取验证码"，输入短信验证码即可完成注册。</p>
<h3>二、登录方式</h3>
<p>98堂支持多种登录方式：</p>
<ul>
<li><strong>账号密码登录</strong>：最常用的登录方式，输入用户名和密码即可</li>
<li><strong>手机验证码登录</strong>：无需记忆密码，通过手机验证码快速登录</li>
<li><strong>扫码登录</strong>：使用98堂APP扫描网页端二维码快速登录</li>
</ul>
<h3>三、安全建议</h3>
<p>为保障您的账户安全，建议：</p>
<ul>
<li>设置高强度密码，避免使用生日、连续数字等简单密码</li>
<li>开启二次验证功能，增加账户安全层级</li>
<li>不要在公共设备上勾选"记住密码"</li>
<li>定期更换密码，建议每3个月更换一次</li>
<li>切勿将账户信息透露给他人</li>
</ul>
<p>如遇到登录问题，可随时联系在线客服获取帮助。</p>`,
    date: '2026-07-28',
    readTime: '5分钟',
    views: 12850,
    tags: ['注册教程', '登录指南', '新手入门', '账户安全'],
  },
  {
    id: 2,
    title: '为什么选择98堂官方入口？安全与稳定性解析',
    category: 'guide',
    excerpt: '了解使用官方入口的重要性，以及98堂如何通过多重技术手段保障用户访问的安全性与稳定性。',
    content: `<p>在互联网时代，选择正确的访问入口至关重要。本文将为您深度解析98堂官方入口的安全保障体系。</p>
<h3>官方入口的优势</h3>
<p>使用官方入口访问98堂，您可以获得以下保障：</p>
<ul>
<li><strong>地址真实性</strong>：官方入口经过严格认证，确保您访问的是真正的98堂平台</li>
<li><strong>数据加密</strong>：全链路HTTPS加密，保护您的登录信息和操作数据</li>
<li><strong>实时同步</strong>：官方入口地址始终保持最新，不用担心链接失效</li>
<li><strong>防钓鱼</strong>：官方入口具备完善的防护机制，有效识别和拦截钓鱼风险</li>
</ul>
<h3>安全技术体系</h3>
<p>98堂采用多层安全防护架构：</p>
<p><strong>传输层安全</strong>：采用TLS 1.3协议，使用256位加密算法，确保数据在传输过程中不被窃取或篡改。</p>
<p><strong>应用层安全</strong>：部署Web应用防火墙（WAF），实时检测和拦截SQL注入、XSS攻击等常见网络威胁。</p>
<p><strong>账户安全</strong>：支持二次验证、异地登录提醒、异常行为检测等多重账户保护机制。</p>
<h3>稳定性保障</h3>
<p>通过全球CDN加速网络和智能DNS解析，98堂官方入口可以在任何网络环境下提供稳定快速的访问体验。系统采用多活架构设计，单点故障自动切换，确保服务连续性。</p>`,
    date: '2026-07-25',
    readTime: '6分钟',
    views: 9820,
    tags: ['官方入口', '安全性', '技术解析', '访问稳定'],
  },
  {
    id: 3,
    title: '98堂访问常见问题汇总（2026年最新版）',
    category: 'faq',
    excerpt: '整理了2026年用户反馈最多的访问相关问题及解决方案，帮助您快速排除故障。',
    content: `<p>本文汇总了2026年用户最常遇到的访问问题及详细解决方案，建议收藏备用。</p>
<h3>Q1：打开98堂显示"无法连接到服务器"</h3>
<p><strong>原因分析</strong>：可能是DNS解析问题、本地网络限制或浏览器缓存异常。</p>
<p><strong>解决方案</strong>：</p>
<ul>
<li>尝试切换本页提供的备用入口地址</li>
<li>清除浏览器缓存和Cookie后重新访问</li>
<li>更换DNS服务器为公共DNS（如114.114.114.114）</li>
<li>尝试使用浏览器的无痕/隐私模式访问</li>
</ul>
<h3>Q2：登录时提示"验证码错误"</h3>
<p><strong>原因分析</strong>：验证码输入有误、验证码已过期或浏览器兼容性问题。</p>
<p><strong>解决方案</strong>：</p>
<ul>
<li>仔细核对验证码大小写</li>
<li>点击验证码图片刷新获取新验证码</li>
<li>切换至Chrome或Edge浏览器尝试</li>
<li>如使用手机验证码，确认手机号码正确且未被拦截</li>
</ul>
<h3>Q3：页面加载缓慢怎么办？</h3>
<p><strong>解决方案</strong>：</p>
<ul>
<li>检查本地网络速度</li>
<li>尝试切换至针对您所在地区优化的备用入口</li>
<li>关闭占用带宽的其他应用</li>
<li>如使用移动网络，尝试切换至WiFi环境</li>
</ul>`,
    date: '2026-07-20',
    readTime: '4分钟',
    views: 15340,
    tags: ['常见问题', '故障排除', '访问帮助', 'FAQ'],
  },
  {
    id: 4,
    title: '98堂安全公告：关于近期网络钓鱼攻击的防范提醒',
    category: 'security',
    excerpt: '近期监测到针对98堂用户的钓鱼攻击活动增加，请广大用户提高警惕，仔细甄别访问地址。',
    content: `<p><strong>发布日期：2026年7月15日</strong></p>
<p>尊敬的用户：</p>
<p>近期我们的安全团队监测到有不法分子通过仿冒98堂网站进行钓鱼攻击，企图窃取用户账户信息。为保障您的账户安全，特此发布防范提醒。</p>
<h3>钓鱼攻击特征</h3>
<ul>
<li>仿冒网站域名与官方地址高度相似，仅有个别字符差异</li>
<li>通过搜索引擎广告、社交平台私信等方式诱导点击</li>
<li>仿冒页面外观与官方网站几乎一致</li>
<li>以"账户异常"、"系统升级"等理由要求输入账户信息</li>
</ul>
<h3>防范措施</h3>
<ul>
<li><strong>认准官方域名</strong>：仅通过本页列出的官方地址访问98堂</li>
<li><strong>检查安全证书</strong>：确认浏览器地址栏显示安全锁图标</li>
<li><strong>不轻信诱导</strong>：官方不会通过私信或弹窗要求您输入密码</li>
<li><strong>及时举报</strong>：如发现可疑网站，请立即向客服举报</li>
</ul>
<p>如您怀疑账户已被盗用，请立即联系客服进行账户冻结处理。</p>
<p>98堂安全团队</p>`,
    date: '2026-07-15',
    readTime: '3分钟',
    views: 22100,
    tags: ['安全公告', '钓鱼攻击', '防范提醒', '账户安全'],
  },
  {
    id: 5,
    title: '98堂手机端访问指南：随时随地畅享服务',
    category: 'guide',
    excerpt: '介绍如何在手机端快速访问98堂，包括浏览器访问和APP下载安装的完整指南。',
    content: `<p>移动互联网时代，随时随地访问98堂是许多用户的需求。本文将介绍手机端访问的最佳方式。</p>
<h3>方式一：手机浏览器访问</h3>
<p>直接在手机浏览器中输入官方地址即可访问，无需额外安装。98堂网页已全面适配移动端，操作流畅、界面友好。</p>
<p><strong>推荐浏览器</strong>：Chrome、Safari、Edge</p>
<h3>方式二：下载官方APP</h3>
<p>98堂官方APP提供更加便捷的访问体验，支持消息推送和指纹/面容快捷登录。</p>
<p><strong>下载方式</strong>：</p>
<ul>
<li>iOS用户：在App Store搜索"98堂"下载</li>
<li>Android用户：通过官方入口页面扫码下载APK安装包</li>
</ul>
<h3>手机端特色功能</h3>
<ul>
<li>一键登录：支持指纹和面容识别，告别繁琐输入</li>
<li>消息推送：重要通知实时送达，不错过任何动态</li>
<li>省流量模式：自动压缩图片和视频，节省移动数据</li>
<li>离线缓存：支持内容离线保存，无网络也能浏览</li>
</ul>`,
    date: '2026-07-10',
    readTime: '4分钟',
    views: 7650,
    tags: ['手机访问', '移动端', 'APP下载', '使用指南'],
  },
  {
    id: 6,
    title: '98堂账户安全设置最佳实践',
    category: 'security',
    excerpt: '全面介绍98堂账户的各项安全设置，帮助您打造一个安全可靠的账户防护体系。',
    content: `<p>账户安全是每位用户都应重视的事项。本文将系统性地介绍98堂账户安全设置的最佳实践。</p>
<h3>密码安全</h3>
<ul>
<li>使用至少12位密码，包含大小写字母、数字和特殊符号</li>
<li>避免使用生日、姓名、连续数字等易被猜测的信息</li>
<li>不同平台使用不同的密码，避免一套密码走天下</li>
<li>推荐使用密码管理器来生成和存储复杂密码</li>
</ul>
<h3>二次验证</h3>
<p>开启二次验证是最有效的账户保护手段之一：</p>
<ul>
<li><strong>短信验证</strong>：登录时需要输入手机收到的验证码</li>
<li><strong>邮箱验证</strong>：通过绑定邮箱接收验证码</li>
<li><strong>身份验证器</strong>：使用Google Authenticator等应用生成动态验证码</li>
</ul>
<h3>登录提醒</h3>
<p>开启登录提醒功能后，每次账户在新设备或新地点登录时，您都会收到通知。如有异常登录，可立即采取措施。</p>`,
    date: '2026-07-05',
    readTime: '5分钟',
    views: 8920,
    tags: ['账户安全', '安全设置', '密码管理', '二次验证'],
  },
  {
    id: 7,
    title: '98堂平台功能全面介绍（2026版）',
    category: 'guide',
    excerpt: '全面了解98堂平台各项核心功能，从基础操作到高级特性，助您充分利用平台资源。',
    content: `<p>98堂平台经过多年发展，已形成丰富完善的功能体系。本文将全面介绍2026年最新版本的核心功能。</p>
<h3>核心功能模块</h3>
<p><strong>内容浏览</strong>：支持图文、视频等多种内容形式的浏览和互动，个性化推荐算法为您精选感兴趣的内容。</p>
<p><strong>社区互动</strong>：评论、点赞、分享、私信等丰富的社交功能，让您与其他用户充分互动交流。</p>
<p><strong>创作中心</strong>：提供便捷的内容创作工具，支持多种格式的内容发布和管理。</p>
<p><strong>个人中心</strong>：集中管理账户信息、安全设置、浏览历史和收藏内容。</p>
<h3>2026年新增功能</h3>
<ul>
<li><strong>智能推荐2.0</strong>：基于深度学习的推荐算法，内容匹配更加精准</li>
<li><strong>多设备同步</strong>：浏览记录和收藏内容在手机和电脑间无缝同步</li>
<li><strong>暗黑模式</strong>：支持深色主题，夜间使用更加护眼舒适</li>
<li><strong>语音搜索</strong>：支持语音输入搜索，操作更加便捷</li>
</ul>`,
    date: '2026-06-28',
    readTime: '8分钟',
    views: 18700,
    tags: ['功能介绍', '平台特色', '新功能', '使用教程'],
  },
  {
    id: 8,
    title: '如何识别和防范仿冒98堂的钓鱼网站',
    category: 'security',
    excerpt: '学习辨别真假98堂网站的关键技巧，保护自己免受网络钓鱼诈骗的侵害。',
    content: `<p>网络钓鱼是互联网上最常见的诈骗手段之一。学会识别真假网站，是保护自己财产安全的重要技能。</p>
<h3>识别真假网站的五个关键点</h3>
<p><strong>1. 检查域名</strong></p>
<p>官方域名为98tang.com及其关联域名。务必逐字核对，注意是否有多余字符或拼写错误。</p>
<p><strong>2. 查看安全证书</strong></p>
<p>点击浏览器地址栏的锁形图标，查看SSL证书信息。确保证书颁发给正确的域名且在有效期内。</p>
<p><strong>3. 观察页面细节</strong></p>
<p>仿冒网站往往在细节上露出破绽：字体不统一、图片模糊、链接失效、版权信息缺失等。</p>
<p><strong>4. 检查联系方式</strong></p>
<p>官方网站底部会有完整的联系方式、备案号和帮助中心入口。</p>
<p><strong>5. 不轻信优惠诱导</strong></p>
<p>如果某个"98堂"网站以超低优惠或中奖信息诱导您输入账户密码，极有可能是钓鱼网站。</p>`,
    date: '2026-06-20',
    readTime: '4分钟',
    views: 11200,
    tags: ['钓鱼网站', '安全防范', '识别技巧', '网络诈骗'],
  },
  {
    id: 9,
    title: '98堂访问速度优化技巧大全',
    category: 'faq',
    excerpt: '分享多种提升98堂访问速度的实用技巧，让您在任何网络环境下都能获得流畅体验。',
    content: `<p>访问速度直接影响用户体验。本文汇集了多种经过验证的速度优化方法。</p>
<h3>浏览器端优化</h3>
<ul>
<li>定期清理浏览器缓存和浏览历史</li>
<li>关闭不必要的浏览器扩展插件</li>
<li>保持浏览器更新至最新版本</li>
<li>开启浏览器的硬件加速功能</li>
</ul>
<h3>网络端优化</h3>
<ul>
<li>使用有线网络连接代替无线连接</li>
<li>更换DNS服务器为更快的公共DNS</li>
<li>关闭占用带宽的后台下载任务</li>
<li>尝试在不同时段访问，避开高峰期</li>
</ul>
<h3>入口选择技巧</h3>
<ul>
<li>根据所在地区选择对应的优化入口</li>
<li>测试不同备用入口的访问速度</li>
<li>将最快的入口添加为浏览器书签</li>
</ul>`,
    date: '2026-06-15',
    readTime: '3分钟',
    views: 6340,
    tags: ['速度优化', '访问技巧', '网络设置', '浏览器优化'],
  },
];